<ng-container *transloco="let t">
  @if(isBrowser) {
        <ng-template #itemList>

            <div class="mobile-filter-checkbox-list" style="padding-top: 8px">
                <div *ngIf="allowSearchItems">
                   <app-search [searchBarClass]="'extra-small'" (searchQuery)="handleInput($event)" [inputValue]="searchText" [id]="id + '-search'"/>
                </div>

                <label class="mobile-filter-checkbox-item" *ngFor="let item of filteredItems">
                    <input type="checkbox"
                            [checked]="item.selected"
                            (change)="toggleItem(item)">
                    <span class="mobile-filter-checkbox-label"> {{ item.labelKey ? t(item.labelKey) : (item.label ?? "-" ) }} </span>
                    <!--      TODO - count implementation -->
                    <!-- <span class="mobile-filter-badge">2</span> -->
                </label>
            </div>
        </ng-template>


        <div *ngIf="isDesktop">
            <div ngbDropdown #desktopDropdown="ngbDropdown" class="dropdown-small me-2" container="body" (openChange)="onDesktopDropdownOpen($event)">
                <div [id]="id" ngbDropdownToggle>
                    {{ title }}
                </div>
                <div ngbDropdownMenu class="scrollable px-3 pb-3 pe-5 mt-1">
                    <ng-container *ngTemplateOutlet="itemList"></ng-container>
                </div>
            </div>
        </div>

        <div *ngIf="!isDesktop">
            <button type="button" class="filter-chip"
                    (click)="onOpenMobileFilter()">
                <span class="filter-chip__label">{{ title }}</span>
                <img src="./assets/img/svg/chevron_down.svg" alt="Chevron down" class="cursor-pointer">
            </button>
        </div>

        <div class="mobile-filter-sheet" *ngIf="!isDesktop && isMobileFilterOpen"  [@slideUpDown]>
          <div class="d-flex justify-content-end sheet-header">
            <button type="button" class="btn-unstyled" data-bs-dismiss="offcanvas" aria-label="Close"
                    (click)="onClose()">
              <img src="assets/img/svg/close-modal.svg" alt="Close modal" style="height: 37px; width: 37px;">
            </button>
          </div>
          <div class="sheet-body">
            <div class="container">
              <div class="pb-16">
                <span class="fs-18 fw-500">{{ title }}</span>
              </div>
              <ng-container *ngTemplateOutlet="itemList"></ng-container>
            </div>
          </div>
          <div class="sheet-footer">
            <div class="row">
              <div class="col">
                <app-button-alt [buttonColor]="'white'" [textColor]="'var(--teal-500)'"
                                [text]="t('app.common.filters.clearAll')" [borderColor]="'var(--teal-500)'"
                                (onClickCallback)="onClear()" [isFullWidth]="true"
                                [isDisabled]="false" [buttonHeight]="'44px'" [fontSize]="'14px'"></app-button-alt>
              </div>
              <div class="col">
                <app-button-alt [buttonColor]="'var(--teal-500)'" [textColor]="'white'"
                                [text]="t('app.register.to.race.apply')" [borderColor]="'var(--teal-500)'"
                                (onClickCallback)="onApply()" [isFullWidth]="true"
                                [isDisabled]="false" [buttonHeight]="'44px'" [fontSize]="'14px'"></app-button-alt>
              </div>
            </div>
          </div>
        </div>
  }
</ng-container>
